import script from "./CasinoGames.vue?vue&type=script&setup=true&lang=js"
export * from "./CasinoGames.vue?vue&type=script&setup=true&lang=js"

import "./CasinoGames.vue?vue&type=style&index=0&id=27ddfbb1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27ddfbb1"]])

export default __exports__